import { render } from "./Bottom_Inscription_Section.vue?vue&type=template&id=20759991"
import script from "./Bottom_Inscription_Section.vue?vue&type=script&lang=js"
export * from "./Bottom_Inscription_Section.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__